module.exports = __webpack_public_path__ + "static/awards-icon-6-4f02607836724ba96891f7ffec2f180c.png";